/**
 * Admin configuration for dev/prod item visibility and other admin-only features.
 */
import { isFamilyMuseumMember } from './familyMuseumMembers';

const ADMIN_EMAILS = String(process.env.REACT_APP_ADMIN_EMAILS || 'jifuzhou90@gmail.com')
  .split(',')
  .map((email) => String(email || '').trim().toLowerCase())
  .filter(Boolean);
const LIMITED_CURRICULUM_ACCESS_EMAILS = String(
  process.env.REACT_APP_LIMITED_CURRICULUM_ACCESS_EMAILS || ''
)
  .split(',')
  .map((email) => String(email || '').trim().toLowerCase())
  .filter(Boolean);

export function isAdmin(email) {
  if (!email) return false;
  return ADMIN_EMAILS.includes(String(email).trim().toLowerCase());
}

export function hasLimitedCurriculumAccess(email) {
  if (!email) return false;
  const normalized = String(email).trim().toLowerCase();
  return LIMITED_CURRICULUM_ACCESS_EMAILS.includes(normalized);
}

/** Same list as backend PHOTO_ALBUM_LABEL_EDITOR_EMAILS — may open album and edit face labels (admin always can). */
const PHOTO_ALBUM_LABEL_EDITOR_EMAILS = String(
  process.env.REACT_APP_PHOTO_ALBUM_LABEL_EDITOR_EMAILS || ''
)
  .split(',')
  .map((email) => String(email || '').trim().toLowerCase())
  .filter(Boolean);

export function hasPhotoAlbumLabelEditAccess(email) {
  if (!email) return false;
  return PHOTO_ALBUM_LABEL_EDITOR_EMAILS.includes(String(email).trim().toLowerCase());
}

/**
 * Album UI hint: site admin, label-editor allowlist, or family museum members
 * (see .env.example).
 *
 * This is only a LOCAL hint — the album gate itself is enforced by the server
 * (see `fetchPhotoAlbumAccess`), so the UI must not treat "true" as proof of
 * access and "false" as a hard block.
 */
export function canAccessPhotoAlbum(email) {
  return (
    isAdmin(email) ||
    hasPhotoAlbumLabelEditAccess(email) ||
    isFamilyMuseumMember(email)
  );
}

export function canEditPhotoAlbumFaceLabels(email) {
  return isAdmin(email) || hasPhotoAlbumLabelEditAccess(email);
}

export function canAccessCurriculumCourseLevel(email) {
  return isAdmin(email) || hasLimitedCurriculumAccess(email);
}
